// import * as app from "./route/app";
import {getClient} from "../../config";

export async function logoutUserAccount() {
  return await getClient().delete({
    path: "/web/users/logout",
  });
}
export async function loginUserAccountWithEmail(data: any) {
  return await getClient().post({
    data,
    path: "/web/users/login/email",
  });
}
export async function signupUserAccountWithEmail(data: any) {
  return await getClient().post({
    data,
    path: "/web/users/sign-up/email",
  });
}
export async function signUpUserAccountOnboarding(data: any) {
  return await getClient().post({
    data,
    path: "/web/users/sign-up/onboarding",
  });
}
export async function signUpVerifyEmailAddress(data: any) {
  return await getClient().post({
    data,
    path: "/web/users/sign-up/onboarding/verify-email",
  });
}
export async function signUpAddPhoneNumberMultifactor(data: any) {
  return await getClient().post({
    data,
    path: "/web/users/sign-up/onboarding/multi-factor/phone-number",
  });
}
export async function signUpAddAuthenticatorMultifactor() {
  return await getClient().post({
    path: "/web/users/sign-up/onboarding/multi-factor/authenticator",
  });
}
export async function signUpVerifyPhoneNumberMultifactor(data: any) {
  return await getClient().patch({
    data,
    path: "/web/users/sign-up/onboarding/multi-factor/phone-number",
  });
}
export async function signUpVerifyAuthenticatorMultifactor(data: any) {
  return await getClient().patch({
    data,
    path: "/web/users/sign-up/onboarding/multi-factor/authenticator",
  });
}
export async function getUserAccountOnboardingData() {
  return await getClient().get({
    path: "/web/users/onboarding-data",
  });
}
export async function loginVerifyWithPhoneNumber(data: any) {
  return await getClient().post({
    path: "/web/users/login/email/verify/phone-number",
    data,
  });
}
export async function loginVerifyWithAuthenticator(data: any) {
  return await getClient().post({
    path: "/web/users/login/email/verify/authenticator",
    data,
  });
}
